import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node.isRequired,
  paymentIcon: PropTypes.element.isRequired
};
function PaymentBlock(_ref) {
  var children = _ref.children,
    paymentIcon = _ref.paymentIcon;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "payment-block",
    "data-testid": "payment-block"
  }, paymentIcon, /*#__PURE__*/React__default.createElement("div", {
    className: "details"
  }, children));
}
PaymentBlock.propTypes = propTypes;

export { PaymentBlock as default };
//# sourceMappingURL=PaymentBlock.js.map
